import { render, staticRenderFns } from "./addBqDbxx.vue?vue&type=template&id=560eae15&scoped=true&"
import script from "./addBqDbxx.vue?vue&type=script&lang=js&"
export * from "./addBqDbxx.vue?vue&type=script&lang=js&"
import style0 from "./addBqDbxx.vue?vue&type=style&index=0&id=560eae15&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560eae15",
  null
  
)

export default component.exports